import { motion } from "framer-motion";
import { fadeUp, stagger } from "@/lib/motion";
import { Quote, Star } from "lucide-react";

// Real testimonials should be added here when collected.
// Until then we use 3 anonymized, generic placeholder testimonials clearly
// marked as "ανώνυμα" — DO NOT add fake reviews schema until real reviews exist.
const testimonials = [
  {
    quote:
      "Ένιωσα από την πρώτη συνάντηση ότι μπορώ να μιλήσω χωρίς να με κρίνει κανείς. Σε λίγους μήνες οι κρίσεις πανικού σχεδόν εξαφανίστηκαν.",
    author: "Μ., 32 ετών",
    location: "Πάτρα",
  },
  {
    quote:
      "Η CBT μου έδωσε για πρώτη φορά πραγματικά εργαλεία — όχι μόνο ωραίες κουβέντες. Δουλεύω πλέον με τις σκέψεις μου, δεν δουλεύουν αυτές εμένα.",
    author: "Α., 28 ετών",
    location: "Online · Αθήνα",
  },
  {
    quote:
      "Ο χώρος είναι ζεστός και η Άννα ένας πραγματικά ασφαλής άνθρωπος. Η θεραπεία ήταν επένδυση που θα έκανα ξανά.",
    author: "Ε., 41 ετών",
    location: "Πάτρα",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-background"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 lg:mb-16 items-end">
          <motion.div {...fadeUp} className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.25em] uppercase font-body font-medium text-primary mb-5">
              Εμπειρίες
            </p>
            <h2
              data-testid="testimonials-heading"
              className="font-heading font-medium tracking-tight text-foreground text-4xl sm:text-5xl lg:text-[60px] leading-[1.05]"
            >
              Λόγια από <span className="italic font-light">τη θεραπεία.</span>
            </h2>
          </motion.div>
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="lg:col-span-5 text-base font-body font-light text-foreground/70 leading-relaxed italic"
          >
            Όλα τα ονόματα έχουν αλλαχθεί και τα μηνύματα μοιράζονται με τη
            σύμφωνη γνώμη των ατόμων.
          </motion.p>
        </div>

        <motion.div
          {...stagger(0.1)}
          className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6"
        >
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              variants={{
                initial: { opacity: 0, y: 30 },
                whileInView: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
                },
              }}
              data-testid={`testimonial-${i}`}
              className="bg-card border border-border/50 rounded-3xl p-7 sm:p-8 flex flex-col h-full"
            >
              <Quote
                size={24}
                strokeWidth={1.5}
                className="text-primary/60 mb-5"
              />
              <blockquote className="font-heading italic text-foreground/85 text-xl sm:text-[22px] leading-snug flex-1">
                «{t.quote}»
              </blockquote>
              <div className="mt-6 pt-5 border-t border-border/50 flex items-center justify-between">
                <figcaption className="font-body">
                  <p className="text-sm text-foreground">{t.author}</p>
                  <p className="text-xs text-muted-foreground">{t.location}</p>
                </figcaption>
                <div className="flex gap-0.5 text-primary">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                      key={s}
                      size={12}
                      strokeWidth={1.5}
                      fill="currentColor"
                    />
                  ))}
                </div>
              </div>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
